import MuiKeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { SvgIconProps } from '@mui/material/SvgIcon';

export type KeyboardArrowRightProps = SvgIconProps;

export const KeyboardArrowRight = (props: KeyboardArrowRightProps) => {
  return <MuiKeyboardArrowRight {...props} />;
};
